import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import WarrantyPageComponent from "./warranty.page";
import {AccessRights} from "lib/constants/accessRights"
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function WarrantyPageContainer() {
  const history = useHistory()
  const hasWarrantyViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Warranty.LIST_READ));
  const hasWarrantyAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Warranty.LIST_WRITE_CREATE));
  const [activeIndex, setActiveIndex] = useState(0);
  const lang = useSelector(state => state.constant.languages);

  useEffect(() => {
    if(!hasWarrantyViewAccessRight){
      history.push('/admin/dashboard')
    }
  }, [history, hasWarrantyViewAccessRight])

  if(!hasWarrantyViewAccessRight) return <LoadingComponent />;

  const tabLabels = [getLang(lang, 'label.WARRANTY_LIST')];

  const handleChange = (event, index) => {
    setActiveIndex(index);
  };

  return (
    <WarrantyPageComponent
      hasWarrantyAddAccessRight={hasWarrantyAddAccessRight}
      handleChange={handleChange}
      activeIndex={activeIndex}
      tabLabels={tabLabels}
      lang={lang}
    />
  );
}

export default WarrantyPageContainer;
